import { highlightSegments } from './moderationFindings'

// HighlightedText repeats one field's text with each phrase finding on that
// field marked. It renders nothing when no finding lands in the text, unless
// plain is set: a transcript chunk under a classifier flag has no span to
// mark and is still worth reading. The caller styles it: classes.root on the
// paragraph, classes.label on the "<label>: " prefix and classes.mark on each
// marked run.
export function HighlightedText({ label, text, findings, field, classes = {}, plain = false }) {
  const segments = highlightSegments(text, findings, field)
  if (!plain && !segments.some((segment) => segment.highlighted)) return null
  return (
    <p className={classes.root}>
      <span className={classes.label}>{label}: </span>
      {segments.map((segment, index) => (segment.highlighted
        ? <mark key={index} className={classes.mark}>{segment.text}</mark>
        : <span key={index}>{segment.text}</span>))}
    </p>
  )
}

export default HighlightedText
